<template>
  <v-container v-style:paddingLeft="$valueByBreakpoint($finPadding.left)" v-style:paddingRight="$valueByBreakpoint($finPadding.right)" class="home" fluid>
    <v-row>
      <v-col id="risksContent"
             cols="12">
        <h1 :style="`text-align: ${isDialog ? 'left': 'center'} !important;`">Risikohinweise finCraft</h1>
        <h2>Informationen</h2>
        <p>Die finCraft Archetypen, die Assetallokation, die Strategiemodelle sowie alle sonstigen Tools sollen den
          Nutzer in seiner selbständigen Entscheidung für eine Anlagestrategie und konkrete Wertpapiere unterstützen
          und dienen rein zu Informationszwecken. Die Vorschläge zu den Anlageklassen und Strategiemodellen basieren
          auf denen von Ihnen gemachten Angaben und berücksichtigen nicht Ihre tatsächlichen finanziellen
          Verhältnisse. Alle Meinungen, Nachrichten, Forschungsergebnisse, Analysen, Kurse oder sonstigen auf dieser
          Website enthaltenen Informationen werden als allgemeine Marktkommentare bereitgestellt. Sie stellen keine
          Anlageberatung dar. FinCraft ist für keinerlei Verluste verantwortlich, die aus einem Investment
          resultieren, das auf einer Prognose oder einer sonstigen bereitgestellten Information beruht. </p>
        <h2>Verlustrisiko</h2>
        <p>Investitionen in Wertpapiere und Vermögensanlagen ist mit erheblichen Risiken verbunden und kann zum
          vollständigen Verlust des eingesetzten Vermögens führen. Der in Aussicht gestellte Ertrag ist nicht
          gewährleistet und kann auch niedriger ausfallen.</p>
        <h2>Inhalte</h2>
        <p>Die Internetinhalte wurden sorgfältig nach bestem Wissen und Gewissen erstellt. Eine Gewähr für die
          Richtigkeit der Informationen, als auch für die Vollständigkeit der hier gemachten Angaben können wir jedoch
          nicht übernehmen. Sollten Sie Ergänzungswünsche haben, würden wir uns freuen, wenn Sie uns diese per E-Mail
          unter <a href="mailto:info@fincraft.de">info@fincraft.de</a> mitteilen. Es gelten zudem die rechtlichen
          Hinweise zur Nutzung der Homepage und die
          Allgemeinen Geschäftsbedingungen der finCraft AG.</p>
        <h2>Positionsüberwachung</h2>
        <p>Sie sollten darüber hinaus gewährleisten, dass Sie in der Lage sind, Positionen in Ihrem Depot jederzeit zu
          überwachen, denn die Verantwortung dafür liegt allein bei Ihnen. Wir sind für die Überwachung der Positionen
          in Ihrem Depot nicht verantwortlich.</p>
        <h2>Wertentwicklung in der Vergangenheit</h2>
        <p>Eine Wertentwicklung in der Vergangenheit lässt nicht auf zukünftige Ergebnisse schließen. Der Wert einer
          Investition kann sowohl fallen als auch steigen.</p>
        <h2>Währungsrisiko</h2>
        <p>Wenn das Wertpapier in einer anderen Währung als Euro erworben wird, können zusätzlich noch
          Wechselkursrisiken für den Anleger entstehen.</p>

        <slot name="append"/>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  name: 'fin-risk-warnings-text',
  props: {
    isDialog: {}
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables";
@import "../../styles/home";

.home {

  h1 {
    color: $fin-color-primary-dark !important;
  }

  h2 {
    color: $fin-color-primary-dark !important;
    margin: 40px 0 6px 0;
    font-size: 32px;
  }

  p {
    color: $fin-color-primary-dark !important;
    margin: 12px 0 6px 0;
  }

  /* Definition for mobile (375px) - vuetify breakpoint for xs */

  @media only screen and (max-width: 600px) {

    h1 {
      font-size: 28px;
    }

    h2 {
      font-size: 22px;
    }

    h3 {
      font-size: 18px;
    }

    p {
      font-size: 16px;
    }

  }
}

</style>
